<button
	type="button"
	[disabled]="['saving', 'saved', 'incomplete', 'unchanged'].includes(state)"
	[ngClass]="{
		'btn-success': state == 'saved' || state == 'saving',
		'btn-primary': state == 'changed',
		'btn-secondary': state == 'unchanged' || state == 'incomplete',
		'btn-warning': state == 'error',
	}"
	(click)="save()"
	class="btn-min btn {{ classes }}"
>
	<ng-container *ngIf="state == 'incomplete'">Incomplete</ng-container>
	<ng-container *ngIf="create && state == 'unchanged'">Create</ng-container>
	<ng-container *ngIf="!create && state == 'unchanged'">Save</ng-container>
	<ng-container *ngIf="create && state == 'changed'">Create</ng-container>
	<ng-container *ngIf="!create && state == 'changed'">Save</ng-container>
	<ng-container *ngIf="state == 'saved'"><i-feather name="check"></i-feather></ng-container>
	<ng-container *ngIf="state == 'saving'"><i-feather name="loader"></i-feather></ng-container>
	<ng-container *ngIf="state == 'error'"><i-feather name="alert-triangle"></i-feather> Error</ng-container>
</button>
